<template>
  <div class="row step-selector no-gutters">
    <div class="col-lg-8">
      <div class="step-inputs page-intro coverage">
        <h3>1. Network Coverage Map</h3>
        <p>Please enter the physical address of where the service will be used.</p>
        <div class="coverage-map-container">
          <vue-coverage-map :lat="-29.1086496" :lng="24.8044103" @place_updated="updatedPlace"></vue-coverage-map>
        </div>
      </div>
      <div class="step-inputs product-selector" v-if="coverage_supported">
        <div class="page-intro">
          <h3>2. Pick Your Deal</h3>
        </div>
        <vue-product-selector :builder="builder" :sim="sim" :product_type="product_type" :callCentre="true" />
      </div>
      <div class="step-inputs device-confirmation" v-if="product_selected && siteMode != 'call-centre'">
        <div class="page-intro">
          <h3>3. Confirm device</h3>
          <p>me<span>&amp;</span>you can only allow the below listed devices (which have been approved by mtn) for
            use with this fixed lte service. Any other devices will not be compatible &amp; your sim will not work.</p>
        </div>
        <div class="lte-devices">
          <h1 class="section-title">
            Approved <span>mtn</span> lte devices
          </h1>          
          <div class="router-types">
            <div class="row no-margin">
              <div class="col">
                <img class="router-img" src="/assets/images/clipart/router_background.jpg" />
                <p class="router-text">
                  zte
                  <br />mf286
                </p>
              </div>
              <div class="col">
                <img class="router-img" src="/assets/images/clipart/router_background.jpg" />
                <p class="router-text">
                  Huawei
                  <br />b525
                </p>
              </div>
              <div class="col">
                <img class="router-img" src="/assets/images/clipart/router_background.jpg" />
                <p class="router-text">
                  Huawei
                  <br />b612
                </p>
              </div>
              <div class="col">
                <img class="router-img" src="/assets/images/clipart/router_background.jpg" />
                <p class="router-text">
                  Huawei
                  <br />b618
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="check-boxes">
          <input
            class="check-box"
            type="checkbox"
            id="compatible-device"
            name="compatible-device"
            v-model="device_confirmed"            
          />
          <label for="compatible-device">I confirm that I will be complying to the MTN compatible device requirements.</label>
          <div
            class="help text-danger"
            v-show="errors.has('compatible-device')"
          >{{ errors.first('compatible-device') }}</div>
        </div>
      </div>

      <div class="step-inputs page-controls">
        <div class="row">
          <div class="col">
            <button
              type="button"
              class="btn btn-block btn-primary next"
              v-on:click="nextStep"
              :disabled="!validSelection"
            >
              Continue
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 deal-info-content">
      <vue-deal-info :builder="builder" />
    </div>
  </div>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import store from "@/store";
import SimModel from "@/models/sim.model";
import VueCoverageMap from "@/components/elements/vue-coverage-map.vue";
import VueProductSelector from "@/components/elements/vue-product-selector";
import VueDealInfo from "@/components/elements/vue-deal-info";
import { CART_UPDATE_CURRENT_ITEM } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "product-selector",
  components: {
    "vue-product-selector": VueProductSelector,
    "vue-deal-info": VueDealInfo,
    "vue-coverage-map": VueCoverageMap
  },
  props: ["builder", "product_type"],
  data: function() {
    return {
      sim: new SimModel(store.state.cart.current_sim),
      coverage_supported: false,
      product_selected: false,
      device_confirmed: false
    };
  },
  computed: {
    ...mapGetters([
      "siteMode"
    ]),
    validSelection() {
      return (
        !this.isEmpty(store.state.cart.current_sim.deal) &&
        this.device_confirmed
      );
    }
  },
  beforeMount() {
    var self = this;
    self.device_confirmed = true;
  },
  methods: {
    updatedPlace(place) {
      var self = this;
      self.sim.user_form = place;
      store.dispatch(CART_UPDATE_CURRENT_ITEM, self.sim);
    },
    nextStep() {
      EventBus.$emit("next-step", true);
    },
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    }
  },
  mounted() {
    var self = this;
    var iccid = self.$route.params.iccid;
    if (typeof iccid != "undefined" && iccid != "" && iccid) {
      self.sim.iccid = iccid;
    }
    // var place = self.$route.params.place;
    // if (typeof place != "undefined" && place != "" && place) {
    //   self.place = place;
    // }

    EventBus.$on("coverage_supported", function(event) {
      self.$log.debug("Coverage Supported", event);
      self.coverage_supported = event;
    });

    EventBus.$on("product_selected", function(event) {
      self.$log.debug("Product select", event);
      self.product_selected = !self.isEmpty(event);
    });

    var selected_deal = self.$route.params.deal;
    if (
      typeof selected_deal != "undefined" &&
      selected_deal != "" &&
      selected_deal
    ) {
      EventBus.$emit("hide_menu", true);

      store.state.products.products.deals.forEach(deal => {
        if (deal.deal_name_id == selected_deal) {
          self.sim.deal = deal;
          self.$log.debug("PRODUCT TYPE", self.product_type);
          self.sim.product_type = self.product_type;
          self.$log.debug("SIM CHANGE", self.sim);
          store.dispatch(CART_UPDATE_CURRENT_ITEM, self.sim);
          self.nextStep();
        }
      });
    }
  }
};
</script>